import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { BsDownload } from "react-icons/bs";

export default function DownloadBtn(props) {
    return (        
            <ReactHtmlTableToExcel
                id="table-xls-button"
                table="table-to-xls"
                filename={props.filename}
                sheet="tablexls"
                buttonText={<button
                    className="p-2 mr-2 rounded text-gray-500 border border-gray-40 hover:bg-gray-100 title-tip"
                    message="Download"
                > <BsDownload /></button>} />        
    )
}
